import { Component, OnInit, ViewChild } from '@angular/core';
import { ReportsService } from '../shared/reports.service';
import { ViewRequest } from '../shared/view-request.model';
import { ViewRequestsComponent } from '../view-requests/view-requests.component';

@Component({
  selector: 'app-requests-student',
  templateUrl: './requests-student.component.html',
  styleUrls: ['./requests-student.component.scss']
})
export class RequestsStudentComponent implements OnInit {

  requests: ViewRequest[];
  testRequests: ViewRequest[];
  enabledSpinner = false;
  valTestStudent = false;
  @ViewChild(ViewRequestsComponent) viewRequestsComponent: ViewRequestsComponent;

  constructor(private reportService: ReportsService) { }

  ngOnInit() {
    this.enabledSpinner = true;
    this.getListRequests();
    this.getValTestRequest();
  }

  getListRequests() {
    const cedStudent = localStorage.getItem('cedula');
    this.reportService.getRequestsStudent(cedStudent).subscribe(
      (result) => {
        if (result.data) {
            this.requests = result.data as ViewRequest[];
            this.enabledSpinner = false;
        }
      }
    );
  }

  getListTestStudent() {
    const cedStudent = localStorage.getItem('cedula');
    this.reportService.getTestStudent(cedStudent).subscribe(
      (result) => {
        if (result.data) {
            this.testRequests = result.data as ViewRequest[];
            this.enabledSpinner = false;
        }
      }
    );
  }

  getValTestRequest() {
    const cedStudent = localStorage.getItem('cedula');
    this.reportService.getValTestRequests(cedStudent).subscribe(
      (result) => {
        if (result.data) {
          this.getListTestStudent();
        }
      }
    );
  }
}
